import React from 'react';
import { components, OptionProps, OptionTypeBase } from 'react-select';

import Checkbox from '../../checkbox';

function nop() {}

const Option = <T extends OptionTypeBase, IsMulti extends boolean>(
  props: OptionProps<T, IsMulti>,
) => {
  const { isMulti, children, ...rest } = props;

  return (
    <components.Option {...rest} isMulti={isMulti}>
      {children}
      {isMulti ? (
        <Checkbox
          value={props.getValue()}
          checked={props.isSelected}
          style={{ marginLeft: 'auto', pointerEvents: 'none' }}
          onChange={nop}
        />
      ) : null}
    </components.Option>
  );
};

export default Option;
